// extracted by mini-css-extract-plugin
module.exports = {"tabWrapper":"TabOptions_tabWrapper__3JTG_","selected":"TabOptions_selected__18Sr2","subtab":"TabOptions_subtab__1UR6N","isActive":"TabOptions_isActive__Xm6mk"};